var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{ref:"appdrawer",staticClass:"page-style row scroll"},[_c('div',{staticClass:"col full-height"},[_c('div',{ref:"contentScroll",staticClass:"content-wrapper scroll"},[_c('div',{staticClass:"content"},[_c('router-view')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }